const actions = {
  SET_STATE: 'CountdownTimer/SET_STATE',
  CHANGE_ENTITY_VALUE: 'CountdownTimer/CHANGE_ENTITY_VALUE',
  RENDER_FUND_INFO: 'CountdownTimer/RENDER_FUND_INFO',
}

export default actions